import { validators, z } from '@frontend/forms';
import { useEffect, useFeatureIsOn } from '@frontend/react';
import { PageContainer, YStack } from '@frontend/web-react';
import { HeaderButton, LetterRecommendationsContainer } from '@frontend/web/components';
import { useListLetterRecommendationsQuery } from '@frontend/web/hooks';
import { createFileRoute, useRouter } from '@tanstack/react-router';

const LetterRecommendation = () => {
  const { enabled: isDiscoverTabEnabled } = useFeatureIsOn('is_discover_tab_enabled');
  const router = useRouter();
  const { data: letterRecommendations, isLoading: isLetterRecommendationsLoading } =
    useListLetterRecommendationsQuery();

  useEffect(() => {
    if (!isDiscoverTabEnabled) {
      router.navigate({ to: '/app/home' });
    }
  }, [isDiscoverTabEnabled]);

  return (
    <PageContainer
      contentContainerClassName="pb-lg flex flex-1 justify-between overflow-y-scroll"
      isLoading={isLetterRecommendationsLoading}
      isScrollable
      padding="none"
    >
      <YStack className="w-full items-center py-lg">
        <YStack className="max-w-screen-lg w-full px-md gap-lg">
          <HeaderButton
            accessibilityLabel="Go back"
            className="bg-cream-200 rounded-md"
            iconName="IconChevronLeft"
            onClick={router.history.back}
            size={18}
          />
          <LetterRecommendationsContainer layout="vertical" letterRecommendations={letterRecommendations ?? []} />
        </YStack>
      </YStack>
    </PageContainer>
  );
};

export const Route = createFileRoute('/app/letter-recommendation/')({
  component: LetterRecommendation,
  validateSearch: (search) =>
    z
      .object({
        letterRecommendationId: validators.uuid().optional(),
      })
      .parse(search),
});
